import {
	getTranslationQuery,
	getTranslationsQuery,
} from 'plugins/i18n/graphql/queries'
import {makeQueryHook} from './helpers'

export const useTranslationQuery = makeQueryHook(getTranslationQuery)

export const useTranslationsQuery = makeQueryHook(getTranslationsQuery)
